module.exports = __webpack_public_path__ + "fonts/ace7f71ef0d9c68e4e035cf7db774956.svg";